module.exports = __webpack_public_path__ + "static/media/34.f373a53f.jpg";